import {
  MerchantButton,
  TextInput,
  EmailInput,
  AutoResizeCurrencyInput,
  FormGroup,
  FormLabel,
  FormError,
} from "@components";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";

const OplPaymentDetails = () => {
  const { merchant, setPaymentParameters, payment } = useOutletContext();

  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { dirtyFields, errors, isValid },
  } = useForm({
    defaultValues: {
      amount: payment?.amount || "",
      name: payment?.customerName || "",
      email: payment?.customerEmail || "",
      reference: payment?.reference || "",
    },
  });

  const onSubmit = (data) => {
    let params = {
      merchantId: merchant.id,
      customerName: data.name,
      amount: data.amount,
      reference: data.reference,
      cardPaymentAllowed: true,
      amexPaymentAllowed: merchant.allowAmex,
      source: "OntikGenericPaymentLink",
      customerEmail: data.email,
      cardPaymentProvider: merchant.cardPaymentProvider,
    };

    setPaymentParameters(params);

    navigate(`/payto/${merchant.organisationId}/choosepaymentmethod`);
  };

  // OB payment handline

  return (
    <div className="w-full flex flex-col items-center grow pt-12">
      <form
        className="max-w-96 w-full flex flex-col items-center"
        onSubmit={handleSubmit(onSubmit)}
      >
        <FormGroup className="w-full flex flex-col items-center py-8">
          <FormLabel className=" text-base">
            Please enter a payment amount
          </FormLabel>
          <AutoResizeCurrencyInput
            name="amount"
            control={control}
            displayName="Amount"
            required
            min={0.3}
            max={999999.99}
            errors={errors.amount}
            className=""
          />
          <FormError name="amount" errors={errors} className="top-[85%]" />
        </FormGroup>
        <div className="border-t border-b flex flex-col gap-y-6 py-8 w-full px-5">
          <FormGroup>
            <FormLabel>Customer name</FormLabel>
            <TextInput
              name="name"
              control={control}
              displayName="Customer name"
              required
              placeholder="Customer name"
              errors={errors.name}
            />
            <FormError name="name" errors={errors} />
          </FormGroup>
          <FormGroup>
            <FormLabel>Email</FormLabel>
            <EmailInput
              name="email"
              control={control}
              displayName="Email"
              required
              placeholder="Email"
              errors={errors.email}
            />
            <FormError name="email" errors={errors} />
          </FormGroup>
          <FormGroup>
            <FormLabel>
              {merchant.genericPaymentReferencePrompt ?? "Payment reference"}
            </FormLabel>
            <TextInput
              name="reference"
              control={control}
              displayName={
                merchant.genericPaymentReferencePrompt ?? "Payment reference"
              }
              required
              placeholder={
                merchant.genericPaymentReferencePrompt ?? "Payment reference"
              }
              errors={errors.reference}
            />
            <FormError name="reference" errors={errors} />
          </FormGroup>
        </div>
        <div className="p-5 pt-14 w-full">
          <MerchantButton merchant={merchant} type="submit" disabled={!isValid}>
            Submit
          </MerchantButton>
        </div>
      </form>
    </div>
  );
};
export default OplPaymentDetails;
